import { render } from "./user-notifications-with-account-menu.vue?vue&type=template&id=4a8bd5ce"
import script from "./user-notifications-with-account-menu.vue?vue&type=script&lang=js"
export * from "./user-notifications-with-account-menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__